import { render } from "./Link.vue?vue&type=template&id=63c2a7a7"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
script.render = render

export default script